import { Navigate, Outlet } from "react-router-dom";

const AdminRoute = () => {
  const userRole = localStorage.getItem("roles");
  
  // Redirect to home or another page if the user is not an admin
  return userRole === "admin" ? <Outlet /> : <Navigate to="/spaceSelect/planning-to-theater" replace />;
};

export default AdminRoute;
